import { dateMinusNDays } from '@whistler-ui/k2/helpers';
import PropTypes from 'prop-types';
import React, { createContext, useContext, useMemo, useReducer } from 'react';

import actions from './actions';
import reducer from './reducer';

const today = new Date();

// @example: Wed May 07 2025 00:00:00 GMT-0300 (Argentina Standard Time)
const startDate = dateMinusNDays(7);

const initialState = {
  useCase: 'Device_Transfer',
  rangeStartDate: startDate,
  rangeEndDate: today,
  rangeOption: undefined,
  useCaseOverview: null,
  useCaseOverviewDashboardFilter: null,
  useCasesStats: null,
  apiStats: [],
  isLoading: true,
  useCasesDetails: null,
  apiStatsDetails: null,
  categories: null,
  useCases: [
    'Device_Transfer',
    // 'Watch_Activation'
  ],
};

const ReportingContext = createContext(undefined);

export function ReportingProvider({ children }) {
  const [newState, dispatch] = useReducer(reducer, initialState);
  const newActions = useMemo(() => actions(dispatch), [dispatch]);

  return (
    <ReportingContext.Provider
      value={[newState, newActions]}
      displayName="ReportingContext"
    >
      {children}
    </ReportingContext.Provider>
  );
}

export const useReportingContext = () => {
  const context = useContext(ReportingContext);

  if (!context) {
    throw new Error(
      'useReportingContext must be used within ReportingProvider',
    );
  }
  return context;
};

ReportingProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
